export function generateSalt(): string {
  const saltBytes = crypto.getRandomValues(new Uint8Array(32));
  return bytesToBase64(saltBytes);
}

export function base64ToBytes(base64: string): Uint8Array {
  if (!base64) {
    throw new Error('base64ToBytes: input is empty or undefined');
  }

  // Handle URL-safe base64 (replace - with + and _ with /)
  const standardBase64 = base64.replace(/-/g, '+').replace(/_/g, '/');

  // Add padding if needed
  const padded = standardBase64.padEnd(
    standardBase64.length + (4 - (standardBase64.length % 4)) % 4,
    '='
  );

  try {
    const binary = atob(padded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return bytes;
  } catch (error) {
    console.error('Failed to decode base64:', base64, error);
    throw new Error('Invalid base64 encoding');
  }
}

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = '';
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}
